var _path, _path2, _path3, _path4, _path5, _g, _circle, _circle2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M481.53 347.033l30.015-191.649c3.121-19.448-10.112-37.747-29.561-40.877L76.973 49.501c-19.448-3.121-37.746 10.112-40.867 29.56l-14.392 89.627v177.23l459.816 1.115z",
    fill: "#146aa8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M481.985 114.507L366.953 96.049C289.694 214.264 164.799 296.142 69.019 346.034l412.511.999 30.015-191.649c3.121-19.449-10.112-37.747-29.56-40.877z",
    fill: "#126099"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.669 159.771h410.192c19.698 0 35.669 15.971 35.669 35.669v231.848c0 19.698-15.971 35.669-35.669 35.669H35.669C15.971 462.956 0 446.986 0 427.288V195.44c0-19.698 15.971-35.669 35.669-35.669z",
    fill: "#4398d1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M445.861 159.771h-7.134c-84.179 149.444-241.469 251.956-337.49 303.185h344.624c19.698 0 35.669-15.971 35.669-35.669V195.44c0-19.698-15.971-35.669-35.669-35.669z",
    fill: "#3e8cc7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdb62f",
    d: "M44.586 204.357h89.172v71.338H44.586z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fd7b2f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.586 231.109h26.752v17.834H44.586zM107.007 231.109h26.752v17.834h-26.752z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 392.358,
    cy: 373.784,
    r: 44.586,
    fill: "#fdb62f"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.854,
    cy: 373.784,
    r: 44.586,
    fill: "#de4c3c"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#87ced9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.669 338.115h53.503v17.834H35.669zM124.841 338.115h53.503v17.834h-53.503zM214.013 338.115h53.503v17.834h-53.503zM35.669 391.619h231.848v17.834H35.669zM312.103 204.357h17.834v35.669h-17.834zM347.772 204.357h17.834v35.669h-17.834zM383.44 204.357h17.834v35.669H383.44zM419.109 204.357h17.834v35.669h-17.834z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardFlat);
export default __webpack_public_path__ + "static/media/credit-card-flat.8ffd77f036a804559eef88e1f0882d5c.svg";
export { ForwardRef as ReactComponent };